import * as React from "react";
import { Datagrid, ExportButton, List, TextField, TopToolbar } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";

const CockpitOutOfStockViewList = props => {
  const ListActions = props => (
    <TopToolbar {...props}>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  const exporter = records => {
    const data = records.map(record => ({
      Pn: record.pn,
      "Pn Description": record.pnDescription,
      "Out Of Stock Count": record.outOfStockCount,
    }));

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Out Of Stock List");
  };

  return (
    <List
      {...props}
      filterDefaultValues={props.filterParams}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField source="pn" />
        <TextField source="pnDescription" />
        <TextField source="outOfStockCount" />
      </Datagrid>
    </List>
  );
};

export default CockpitOutOfStockViewList;
